var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinUranium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8742_5850)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8269 52.8278H43.6405V38.4411C43.6405 35.0105 43.5792 30.5942 38.8626 30.5942C34.078 30.5942 33.3458 34.3322 33.3458 38.1914V52.8268H24.1597V23.2422H32.9784V27.2852H33.1019C33.9845 25.7762 35.2598 24.5347 36.7921 23.6931C38.3244 22.8516 40.0563 22.4413 41.8033 22.5062C51.1142 22.5062 52.8308 28.6306 52.8308 36.5981L52.8269 52.8278ZM13.794 19.1984C10.8498 19.1988 8.46251 16.8123 8.46203 13.8681C8.46155 10.9238 10.8478 8.53654 13.7921 8.53605C16.7364 8.53533 19.1236 10.9218 19.1241 13.8661C19.1243 15.28 18.5629 16.6361 17.5634 17.6361C16.5638 18.6361 15.2079 19.198 13.794 19.1984ZM18.3874 52.828H9.19126V23.2422H18.3871V52.8278L18.3874 52.828ZM57.4067 0.00451241H4.57516C2.07821 -0.0235813 0.0305156 1.97665 0 4.4736V57.5255C0.0295469 60.0237 2.077 62.0258 4.57492 61.9997H57.4067C59.9099 62.0307 61.9654 60.0285 62 57.5255V4.46948C61.9644 1.96768 59.9087 -0.0323001 57.4067 0.000395224",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8742_5850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinUranium);
export default __webpack_public_path__ + "static/media/linkedin-uranium.ef287f646a73fb716708d0a423e0feba.svg";
export { ForwardRef as ReactComponent };